import React from "react";

export const About = () => (
  <section id="about" className="section-mv bg-brand-surface">
    <div className="container-mv grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6">
        <div className="relative rounded-2xl overflow-hidden shadow-premium-hover border border-neutral-200">
          <img
            src="https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85"
            alt="Mavtech technician working"
            className="w-full h-[420px] object-cover"
            loading="lazy"
          />
        </div>
      </div>
      <div className="lg:col-span-6">
        <div className="text-xs font-semibold tracking-widest text-brand-red uppercase">About Mavtech</div>
        <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-black">
          Tire service — <span className="text-brand-red">simple &amp; convenient.</span>
        </h2>
        <p className="mt-5 text-neutral-700 text-base leading-relaxed">
          Mavtech Mobile Tires was founded to make tire service simple and convenient. Instead of waiting in busy repair shops, customers receive professional tire service wherever their vehicle is located.
        </p>
        <p className="mt-4 text-neutral-700 text-base leading-relaxed">
          We believe in honest workmanship, quality equipment, transparent pricing, and excellent customer service. Every vehicle is treated with care as if it were our own.
        </p>
        <div className="mt-8 grid grid-cols-3 gap-4">
          {[
            { k: "5★", v: "Rated Service" },
            { k: "6+", v: "Communities Served" },
            { k: "24/7", v: "Roadside Response" },
          ].map((s) => (
            <div key={s.v} className="rounded-xl border border-neutral-200 bg-white p-4">
              <div className="font-display text-2xl font-extrabold text-brand-red">{s.k}</div>
              <div className="text-xs text-neutral-600 mt-1">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
